<template>
  <div class="assessment-tab">
    <el-collapse v-if="vacancies.length" v-model="assessmentCollapse" accordion>
      <el-collapse-item
        v-for="(vacancy, index) in vacancies"
        :key="vacancy.vacancy_id"
        :name="`${vacancy.lbl}_${index}`"
        :title="formatHtml(vacancy.lbl)"
        :disabled="requestSent"
      >
        <el-form
          v-if="
            vacancy.checklist_data &&
            vacancy.checklist_data.panels &&
            Object.keys(vacancy.checklist_data.panels).length
          "
          v-scroll="scrollTab"
          :model="mainForm[vacancy.vacancy_id].form"
          :rules="rules"
          :ref="vacancy.vacancy_id"
          status-icon
          class="assessment-form demo-ruleForm"
          label-position="top"
          size="mini"
        >
          <div
            :id="`check-list-${vacancy.vacancy_id}`"
            class="assessment-form__wrapper"
          >
            <div
              class="assessment-form__section"
              v-for="(section, key) in mainForm[vacancy.vacancy_id].panels"
              v-show="section.rows && section.rows.length"
              :key="key"
            >
              <h3 v-if="section.LBL" class="primary">{{ section.LBL }}</h3>
              <div
                v-for="(item, j) in section.rows"
                :key="`${key}_${j}`"
                :class="[
                  'row',
                  asmRowWithBorderClass(item.fields[0], section.name),
                  section.name === QUESTION_TYPE.INTERVIEW_RESULTS
                    ? 'row--white-bg'
                    : ''
                ]"
              >
                <div
                  v-if="section.name === QUESTION_TYPE.JOB_EXPERIENCE"
                  class="candidate-jobs"
                >
                  <div class="candidate-jobs__header">
                    <Input
                      :field="{ readonly: true }"
                      :model="formatHtml(item.job.company_name)"
                      class="candidate-jobs__header-item"
                    />
                    <Input
                      :field="{ readonly: true }"
                      :model="formatHtml(item.job.post)"
                      class="candidate-jobs__header-item"
                    />
                    <Input
                      :field="{ readonly: true }"
                      :model="`${item.job.period_begin} — ${
                        item.job.period_end || 'настоящее время'
                      }`"
                      class="candidate-jobs__header-item"
                    />
                  </div>

                  <AssessmentRow
                    v-for="(field, k) in item.fields"
                    :key="`${key}_${j}_${k}_${field.question_id}`"
                    :field="field"
                    :model="
                      mainForm[vacancy.vacancy_id].job_experience[item.job.id][
                        field.question_id
                      ]
                    "
                    :options="options"
                    :datepicker="datepicker"
                    :item="item"
                    :vacancy_id="vacancy.vacancy_id"
                    :select-type="selectType(field.answer_type)"
                    class-name="row row--with-border"
                    @set-value="setAnswerValue"
                  ></AssessmentRow>
                </div>

                <div
                  v-else-if="section.name === QUESTION_TYPE.INTERVIEW_RESULTS"
                  class="interview-results"
                >
                  <div class="interview-results__top">
                    <div
                      class="interview-results__person primary"
                      v-if="item.subfields.person"
                      v-html="
                        $sanitize(assessmentPerson(item.subfields.person))
                      "
                    ></div>
                    <div
                      class="interview-results__rate"
                      v-if="item.subfields.rate"
                    >
                      <Rating
                        :name="item.subfields.rate.name"
                        :model="
                          Number(
                            mainForm[vacancy.vacancy_id].interview_results[
                              item.subfields.rate.name
                            ]
                          ) || 0
                        "
                        @set-value="
                          (name, val) =>
                            $set(
                              mainForm[vacancy.vacancy_id].interview_results,
                              name,
                              val
                            )
                        "
                      />
                    </div>
                  </div>
                  <Textarea
                    v-if="item.subfields.text"
                    :field="item.subfields.text"
                    :hasResizeIcon="true"
                    :model="
                      mainForm[vacancy.vacancy_id].interview_results[
                        item.subfields.text.name
                      ]
                    "
                    @change="
                      (name, val) =>
                        $set(
                          mainForm[vacancy.vacancy_id].interview_results,
                          name,
                          val
                        )
                    "
                  />
                </div>
                <assessment-row
                  v-else
                  v-for="(field, k) in item.fields"
                  :key="`${key}_${j}_${k}_${field.question_id}`"
                  :field="field"
                  :model="mainForm[vacancy.vacancy_id].form[field.question_id]"
                  :options="options"
                  :datepicker="datepicker"
                  :item="item"
                  :vacancy_id="vacancy.vacancy_id"
                  :select-type="selectType(field.answer_type)"
                  @set-value="setAnswerValue"
                ></assessment-row>
              </div>
            </div>
          </div>
          <div
            :id="`button-${vacancy.vacancy_id}`"
            class="assessment-form__button-panel"
          >
            <Button
              buttonSize="big"
              :hasLeftIcon="true"
              buttonColor="blue"
              iconName="CircleOk"
              iconColor="#0075DB"
              :buttonText="vacancy.checklist_data.bottom_buttons[0].lbl.value"
              vacancy.checklist_data
              @click="
                saveAssessmentForm(
                  vacancy.vacancy_id,
                  vacancy.checklist_data.bottom_buttons[0].intents,
                  vacancy.checklist_data.interview_report_id
                )
              "
            />
            <!-- @click="saveAssessmentForm(vacancy.vacancy_id)" -->
          </div>
        </el-form>
        <div class="empty" v-else>ffff Нет данных</div>
      </el-collapse-item>
    </el-collapse>
    <div v-else-if="!vacancies.length">
      <Alert text="Прикрепленных вакансий еще нет" />
    </div>
  </div>
</template>
<script>
import { store } from '@/store';
import { Collapse, CollapseItem, Form } from 'element-ui';
import { mixin } from '@/utils/mixins';
import { setDateFormat } from '@/utils/helpers';
import { ANSWER_TYPE, QUESTION_TYPE } from '@/utils/constants';
import AssessmentRow from 'Elements/Tab/AssessmentRow';
import Button from 'Elements/Button/Button';
import Textarea from 'Elements/Textarea/Textarea';
import Input from 'Elements/Input/Input';
import Rating from 'Elements/Rating/Rating';
import merge from 'lodash/merge';
import Alert from 'Elements/Alert/Alert';
import { postController } from '@/controllers/request.js';

export default {
  mixins: [mixin],
  props: {
    metadata: Object
  },
  data() {
    return {
      QUESTION_TYPE,
      assessmentCollapse: '',
      mainForm: {},
      options: {},
      datepicker: {
        dateFormat: '',
        timeFormat: 'HH:mm'
      },
      rules: {},
      vacancies: []
    };
  },
  created() {
    this.vacancies = this.metadata.metadata;

    if (
      Array.isArray(this.vacancies) &&
      this.vacancies.length &&
      this.metadata.current_date_format
    ) {
      for (let i = 0; i < this.vacancies.length; i++) {
        if (
          this.vacancies[i]?.vacancy_id &&
          this.vacancies[i]?.checklist_data?.panels
        ) {
          this.setAssessmentCollapseTab(
            this.vacancies[i].vacancy_id,
            this.vacancies[i].checklist_data.panels,
            this.metadata.current_date_format
          );
        }
      }
    }
  },
  computed: {
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    }
  },
  methods: {
    handleChange(name, val, form) {
      this.$set(form, name, val);
    },
    scrollTab() {
      const id = this.assessmentCollapse;
      const form = document.getElementById(`check-list-${id}`);
      if (!form) return;

      const button = document.getElementById(`button-${id}`);
      const formTop = form.getBoundingClientRect().top - form.offsetTop;
      const formHeight = form.offsetHeight;

      if (window.scrollY >= formTop && window.scrollY < formHeight) {
        if (button.classList.contains('relative')) {
          button.classList.remove('relative');
        }
        return;
      }

      button.classList.add('relative');
    },
    selectType(type) {
      return (
        type === ANSWER_TYPE.DROPDOWN_ANSWER ||
        type === ANSWER_TYPE.MULTIENUM_ANSWER
      );
    },
    setAssessmentCollapseTab(vacancy_id, panels, current_date_format) {
      this.$emit('set-loading', true);
      // расставить rules
      if (vacancy_id && !this.mainForm[vacancy_id] && !this.requestSent) {
        this.requestSent = true;

        const sectionsOrder = [
          QUESTION_TYPE.GENERAL,
          QUESTION_TYPE.MOTIVATION,
          QUESTION_TYPE.JOB_EXPERIENCE,
          QUESTION_TYPE.SKILLS_ASSESSMENT,
          QUESTION_TYPE.INTERVIEW_RESULTS
        ];
        const sortedPanels = [];
        sectionsOrder.forEach(section => {
          if (panels.hasOwnProperty(section)) {
            sortedPanels.push({ ...panels[section], name: section });
          }
        });
        const data = { panels: sortedPanels }; // потом убрать panels
        const form = {};
        const radioForm = {
          // для radio вынужденное хранение верного формата value, иначе v-model с массивом не работает
          job_experience: {},
          answers: {}
        };
        const interview_results = {};
        const job_experience = {};

        if (current_date_format) {
          this.$set(
            this.datepicker,
            'dateFormat',
            setDateFormat(current_date_format)
          );
        }

        for (let section in data.panels) {
          const sections = [
            QUESTION_TYPE.JOB_EXPERIENCE,
            QUESTION_TYPE.SKILLS_ASSESSMENT
          ];
          const sectionName = data.panels[section].name;
          if (
            sections.includes(sectionName) &&
            Object.keys(data.panels[section]).length > 1
          ) {
            // обработка данных с одинаковой структурой в panels
            const { rows, candidateJobsData, skillsData } =
              data.panels[section];
            const dataKey = candidateJobsData
              ? 'job'
              : skillsData
              ? 'skill'
              : 'data';
            const objData = candidateJobsData || skillsData;
            const dataIds = Object.keys(rows);
            const fields = Object.values(rows);
            const fieldsData = Array.from(fields, (field, idx) => {
              if (candidateJobsData) {
                this.$set(job_experience, dataIds[idx], {});
                this.$set(radioForm.job_experience, dataIds[idx], {});
              }

              return Object.assign(
                {},
                {
                  ...field,
                  [dataKey]: {
                    id: dataIds[idx],
                    ...objData[dataIds[idx]]
                  }
                }
              );
            });
            this.$set(data.panels[section], 'rows', fieldsData);
          }

          if (Array.isArray(data.panels[section].rows)) {
            const { name, rows } = data.panels[section];
            rows.forEach(row => {
              if (name === QUESTION_TYPE.INTERVIEW_RESULTS) {
                const subfields = {};
                row.fields.forEach(field => {
                  subfields[field.subtype] = field;
                  switch (field.subtype) {
                    case 'rate':
                      interview_results[field.name] = Number(field.value);
                      break;

                    case 'text':
                      interview_results[field.name] = this.formatHtml(
                        field.value
                      );
                      break;

                    default:
                      break;
                  }
                });
                this.$set(row, 'subfields', subfields);
              } else {
                row.fields.forEach(field => {
                  const { answer_type, answer_options, question_id, value } =
                    field;
                  // определяем путь к форме в зависимости от раздела
                  const localForm =
                    name === QUESTION_TYPE.JOB_EXPERIENCE
                      ? job_experience[row.job.id]
                      : form;
                  const localRadioForm =
                    name === QUESTION_TYPE.JOB_EXPERIENCE
                      ? radioForm.job_experience[row.job.id]
                      : radioForm.answers;

                  switch (answer_type) {
                    case ANSWER_TYPE.RATING_ANSWER:
                    case ANSWER_TYPE.SCALE_ANSWER:
                      localForm[question_id] = Number(value);
                      break;

                    case ANSWER_TYPE.TEXT_ANSWER:
                    case ANSWER_TYPE.LINE_ANSWER:
                      localForm[question_id] = this.formatHtml(value);
                      break;

                    case ANSWER_TYPE.OPTION_ANSWER:
                      localForm[question_id] = value[0] || '';
                      localRadioForm[question_id] = value;
                      break;

                    default:
                      localForm[question_id] = value;
                      break;
                  }

                  if (this.selectType(answer_type) && answer_options) {
                    const options = [];
                    for (let optKey in answer_options) {
                      options.push({
                        id: optKey,
                        name: this.formatHtml(answer_options[optKey])
                      });
                    }
                    this.options[question_id] = options;
                  }
                });
              }
            });
          }
        }

        this.$set(this.mainForm, vacancy_id, {
          ...data,
          form,
          radioForm,
          job_experience,
          interview_results
        });
      }

      this.requestSent = false;
      this.$emit('set-loading', false);
    },
    assessmentPerson(data) {
      const { lbl_text, value } = data;
      return `${lbl_text} ${value || ''}`;
    },
    asmRowWithBorderClass(field, sectionName) {
      return field.answer_type && sectionName !== QUESTION_TYPE.JOB_EXPERIENCE
        ? 'row--with-border'
        : '';
    },
    setAnswerValue(value, vacancyId, field, jobId) {
      const { question_id, answer_type } = field;
      const form = jobId
        ? this.mainForm[vacancyId].job_experience[jobId]
        : this.mainForm[vacancyId].form;
      const radioForm = jobId
        ? this.mainForm[vacancyId].radioForm.job_experience[jobId]
        : this.mainForm[vacancyId].radioForm.answers;

      switch (answer_type) {
        case ANSWER_TYPE.DATE_ANSWER:
        case ANSWER_TYPE.DATETIME_ANSWER:
          this.$set(form, question_id, value || '');
          break;

        case ANSWER_TYPE.OPTION_ANSWER:
          this.$set(radioForm, question_id, value ? [value] : []);
          break;

        default:
          this.$set(form, question_id, value);
          break;
      }
    },
    saveAssessmentForm(vacancyId, intents, interview_report_id) {
      this.$refs[vacancyId][0].validate(valid => {
        if (valid) {
          this.$emit('set-loading', true);
          if (!this.requestSent) {
            this.requestSent = true;

            const data = this.mainForm[vacancyId];
            const { form, radioForm, interview_results, job_experience } = data;
            const formData = new FormData();
            const params = {
              data: JSON.stringify({
                interview_report_id,
                answers: merge(form, radioForm.answers),
                job_experience: merge(job_experience, radioForm.job_experience),
                interview_results
              }),
              ...intents[0].request.request_params
            };

            for (let key in params) {
              formData.set(key, params[key]);
            }

            postController({ options: formData })
              .then(() => {
                this.$emit('reloadTab', false);
              })
              .catch(err =>
                this.catchError(
                  err,
                  'Возникла ошибка сохранения формы оценки',
                  'save assessment form'
                )
              )
              .finally(() => {
                this.requestSent = false;
                this.$emit('set-loading', false);
              });
          }
        }
      });
    }
  },
  components: {
    AssessmentRow,
    'el-collapse': Collapse,
    'el-collapse-item': CollapseItem,
    Rating,
    Alert,
    'el-form': Form,
    Button,
    Input,
    Textarea
  }
};
</script>

<style lang="scss">
.assessment-tab {
  background: $white;
  padding: 24px;
  text-align: left;

  .el-collapse {
    border: none;

    &-item {
      margin-bottom: 5px;

      &__header {
        display: flex;
        background-color: #fff;
        height: 32px;
        font-size: 24px;
        line-height: 32px;
        font-weight: bold;
        color: $black-190;
        margin-bottom: 20px;
        border: none;

        &.is-active {
          color: $black-190;
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
        }
      }

      &__arrow {
        content: url('../../../../src/assets/img/arror-down-bold.svg');
        margin: 0;
        margin-left: 16px;

        &.is-active {
          -webkit-transform: rotate(-180deg);
          transform: rotate(-180deg);
        }
      }

      &__wrap {
        border: none;
        background: inherit;
      }

      &__content {
        font-size: 1em;
        padding-bottom: 0;
      }
    }

    .empty {
      color: #909399;
    }

    .assessment-form {
      h3 {
        margin-top: 0;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        // color: $blue-120;
        align-self: stretch;
        -ms-grid-row-align: stretch;
        margin-bottom: 0;
      }

      label {
        margin: 0;
        padding: 0;
      }

      .el-date-editor.el-input {
        width: 50%;
      }

      .el-radio:not(:last-of-type) {
        margin-right: 40px;
      }

      &__section {
        // padding: 24px;
        background: $white;

        &:not(:last-child) {
          margin-bottom: 24px;
        }

        .row:last-child .el-radio {
          padding: 0;
        }
      }

      &__wrapper {
        display: inline-block;
        width: 100%;
        // padding: 24px;
        box-sizing: border-box;
      }

      &__button-panel {
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-content: center;
        padding: 12px;
        margin: auto;
        width: 100%;
        max-width: 872px;
        bottom: 0;
        z-index: 99;
        // position: fixed;
        // border-top: 1px solid $black-30;

        // .el-button {
        //   height: 40px;
        //   width: 208px;
        //   text-transform: unset;
        //   color: $blue-120;
        //   background: #eff8ff;
        //   border: unset;
        //   align-self: center;
        //   -ms-grid-row-align: center;

        //   &:hover {
        //     background: #d6ebff;
        //   }

        //   :disabled {
        //     background: $black-10;
        //     color: $black-50;
        //   }
        // }

        &.relative {
          position: relative;
          max-width: 100%;
          bottom: 0;
          right: 0;
        }
      }

      .row {
        margin: 0;
        margin-top: 16px;
        overflow: hidden;
        margin-bottom: 0 !important;

        &--with-border {
          border-radius: 3px;
        }

        &:last-child label.el-radio {
          margin-bottom: 0;
        }
      }

      .el-radio {
        display: inline-block;
        margin-bottom: 4px;

        &__label {
          line-height: 24px;
          display: inline-block;
          vertical-align: middle;
          // color: #282f36;
          font-size: 16px;
          padding-left: 8px;
        }

        &__inner {
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
      }

      .el-rate__icon {
        font-size: 24px;
        margin-right: 4px;
        // height: 24px;
      }

      .el-form-item {
        margin-bottom: 0;

        // &__content {
        //   padding-top: 12px;
        // }

        &__label {
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
          color: $grey80;
        }
      }

      .candidate-jobs {
        margin-bottom: 15px;

        &__header {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          &-item {
            // color: $black-50;
            border-radius: 4px;
            align-content: center;

            .el-input {
              height: 40px !important;
              resize: none !important;
              border-radius: 4px;

              &__inner {
                height: 40px !important;
                padding: 8px 16px;
                font-size: 16px;
                line-height: 24px;
                color: $black-50;
                background: white;
                border-radius: 4px;
              }
            }

            &:not(:first-child) {
              margin-left: 32px;
              height: 40px;
              align-content: center;
            }
          }
        }

        .el-form-item__content {
          width: 50%;
        }

        &__answer {
          display: grid;
          grid-auto-flow: column;
          grid-auto-columns: 130px auto;
          margin-bottom: 5px;

          label {
            font-size: 12px;
            line-height: 28px;
          }
        }
      }

      .interview-results {
        // &__top {
        //   margin-bottom: 12px;
        // }

        &__rate {
          // position: absolute;
          float: right;
        }

        &__person {
          // position: absolute;
          float: left;
        }
      }

      .is-disabled {
        opacity: 1;

        input,
        textarea {
          border: 1px solid $black-30 !important;
          background-color: $black-10 !important;
          color: $black-50 !important;
        }
      }
    }
  }
}
</style>
